import { CustomPropertyCategory, PublishCustomPropertiesDocument } from "generated/graphql";
import { useCallback, useState } from "react";
import { runGqlMutation } from "gqlClient";
import { PublishInfo, PublishModal } from "routes/lens-editor/PublishModal";
import theme from "theme";

interface PublishPropertiesModalProps {
  lensId: number;
  customPropertyCategory: CustomPropertyCategory;
  open: boolean;
  close: () => void;
}

const PublishCustomPropertiesModal = (props: PublishPropertiesModalProps) => {
  const { lensId, customPropertyCategory } = props;
  const [updateInfo, setUpdateInfo] = useState<PublishInfo[]>([]);
  const [dryrun, setDryrun] = useState(true);
  const [error, setError] = useState("");
  const [disabled, setDisabled] = useState(false);
  const getCustomPropCategoryText = () => {
    switch (customPropertyCategory) {
      case CustomPropertyCategory.CaseCalcProperty:
        return "Calcs";
      case CustomPropertyCategory.CaseCustomProperty:
        return "Custom Properties";
      case CustomPropertyCategory.DocumentProperty:
        return "Document Properties";
    }
  };
  const noIssueText = <p style={{ color: theme.palette.success.main }}>No Issues Detected</p>;

  const handlePublishCustomProperties = async (dryrun: boolean, onlyPublishLensIds: number[]) => {
    setDisabled(true);
    setDryrun(dryrun);
    return runGqlMutation(PublishCustomPropertiesDocument, {
      lensId,
      customPropertyCategory,
      dryrun,
      onlyPublishLensIds,
    })
      .then((response) => {
        setUpdateInfo(
          response.lens.customProperties.publishCustomProperties.updateInfo.map((info) => {
            return { ...info, noIssueText: noIssueText };
          })
        );
        setError("");
        setDisabled(false);
      })
      .catch((e) => {
        setError(e.message);
        setDisabled(false);
      });
  };

  const dryrunOnMount = useCallback(() => {
    handlePublishCustomProperties(true, []);
  }, []);

  return (
    <PublishModal
      ref={dryrunOnMount}
      open={props.open}
      error={error}
      dryrun={dryrun}
      isDisabled={disabled}
      updateInfo={updateInfo}
      close={props.close}
      publish={(onlyPublishLensIds: number[]) => handlePublishCustomProperties(false, onlyPublishLensIds)}
      header={`Publish ${getCustomPropCategoryText()}`}
      text={
        `Publish ${getCustomPropCategoryText()} to the following lenses? ` +
        `Note: This operation never deletes properties in the targeted lenses.`
      }
    />
  );
};

export default PublishCustomPropertiesModal;
